import React, { useEffect, useState } from 'react';
import traitCounts from '../traitCounts.json'; // Adjust the path as necessary

const Filters = ({ filters, handleFilterChange, resetFilters, metadata }) => {
  const [distribution, setDistribution] = useState({});

  useEffect(() => {
    setDistribution(traitCounts);
  }, []);

  const toggleFilter = (filterType, value) => {
    handleFilterChange(filterType, filters[filterType] === value ? '' : value);
  };

  return (
    <aside className="w-full md:w-1/4 p-4">
      <div className="block md:hidden mb-4">
        {['base', 'vision', 'noise', 'flavour'].map((filterType) => (
          <select
            key={filterType}
            onChange={(e) => handleFilterChange(filterType, e.target.value)}
            className="w-full p-2 border border-[#632af8] rounded mb-4 bg-black text-[#632af8]"
            value={filters[filterType]}
          >
            <option value="">Select {filterType.charAt(0).toUpperCase() + filterType.slice(1)}</option>
            {[...new Set(metadata.flatMap((item) => item.traits.filter((trait) => trait.type === filterType).map((trait) => trait.value)))].map((value) => (
              <option key={value} value={value}>
                {value} ({distribution[`${filterType}Distribution`]?.[value] || 0})
              </option>
            ))}
          </select>
        ))}
      </div>
      <div className="hidden md:block mb-4">
        {['base', 'vision', 'noise', 'flavour'].map((filterType) => (
          <div key={filterType} className="mb-4">
            <div className="block w-full text-left mb-2 text-[#f42b91] text-lg font-bold p-1 rounded bg-black border border-[#632af8]">
              {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
            </div>
            <div className="flex flex-wrap gap-2">
              {[...new Set(metadata.flatMap((item) => item.traits.filter((trait) => trait.type === filterType).map((trait) => trait.value)))].map((value) => (
                <button
                  key={value}
                  onClick={() => toggleFilter(filterType, value)}
                  className={`p-1 text-sm border border-[#632af8] rounded ${filters[filterType] === value ? 'bg-black' : 'bg-gray-700'} text-[#00f6ff] hover:bg-[#632af8] hover:text-[#000000]`}
                >
                  {value.toLowerCase()} <span className="text-xs">({distribution[`${filterType}Distribution`]?.[value] || 0})</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button onClick={resetFilters} className="w-full p-2 border border-[#632af8] rounded bg-black text-[#632af8] mt-4 hover:bg-[#632af8] hover:text-[#000000]">
        Reset
      </button>
    </aside>
  );
};

export default Filters;